import script from "./Geo.vue?vue&type=script&setup=true&lang=js"
export * from "./Geo.vue?vue&type=script&setup=true&lang=js"

import "./Geo.vue?vue&type=style&index=0&id=2ba0de58&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ba0de58"]])

export default __exports__